import { SmileOutlined } from '@ant-design/icons';
import { Input, Popover } from 'antd';
import { useState } from 'react';

// Danh sách emoji phổ biến để CHỌN NHANH. Emoji là chuỗi Unicode bất kỳ — vẫn gõ tay được.
const EMOJIS = [
  '🔥', '💰', '🎬', '🌍', '👋', '✅', '⭐', '❤️', '😀', '😁', '😂', '🤣', '😍', '😎', '🤩', '😉',
  '😮', '😱', '🥳', '🤔', '👍', '👎', '👏', '🙏', '💪', '🙌', '🤝', '✨', '💥', '💯', '🎉', '🎁',
  '🚀', '⚡', '💡', '📈', '📉', '🏆', '🥇', '🎯', '🔔', '📢', '📌', '⏰', '💎', '👑', '🛍️', '🛒',
  '💳', '🏷️', '🆕', '🆓', '🔝', '⬆️', '⬇️', '➡️', '⬅️', '❓', '❗', '⚠️', '🚨', '🔒', '🔑', '🎵',
  '🎶', '😢', '😭', '😡', '🤯', '🥹', '😴', '🤤', '😋', '😜', '🤗', '🫶', '🤙', '👀', '🧠', '💬',
  '🗣️', '🌟', '🌈', '☀️', '🌙', '💧', '🍀', '🌹', '🍔', '🍕', '🍷', '☕', '🎮', '📱', '💻', '📷',
];

export function EmojiPicker({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}) {
  const [open, setOpen] = useState(false);
  const grid = (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: 4, width: 296, maxHeight: 220, overflow: 'auto' }}>
      {EMOJIS.map((e) => (
        <span
          key={e}
          role="button"
          onClick={() => {
            onChange(e);
            setOpen(false);
          }}
          style={{ cursor: 'pointer', fontSize: 20, textAlign: 'center', padding: 2, borderRadius: 4 }}
        >
          {e}
        </span>
      ))}
    </div>
  );
  return (
    <Input
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      addonAfter={
        <Popover open={open} onOpenChange={setOpen} trigger="click" content={grid} title="Chọn emoji (hoặc gõ bất kỳ)">
          <SmileOutlined style={{ cursor: 'pointer' }} />
        </Popover>
      }
    />
  );
}
